import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles({
  statusIndicator: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    display: "inline-block",
    border: "2px solid #fff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    transition: "transform 0.2s ease-in-out",
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.2)",
    },
  },
});

const StatusIndicatorTicket = ({ status }) => {
  const classes = useStyles();

  // Determina a cor e legenda do status
  const getStatusDetails = (status) => {
    switch (status) {
      case "closed":
        return { color: "#4CAF50", label: "Resolvido" };
      case "pending":
        return { color: "#FFC107", label: "Aguardando" };
      case "open":
        return { color: "#2196F3", label: "Em Andamento" };
      default:
        return { color: "gray", label: "Desconhecido" };
    }
  };

  const { color, label } = getStatusDetails(status);

  return (
    <Tooltip title={label} arrow>
      <span
        className={classes.statusIndicator}
        style={{ backgroundColor: color }}
      ></span>
    </Tooltip>
  );
};

export default StatusIndicatorTicket;
